var baseApiUrl = process.env.REACT_APP_MANAGE_ISSUE_BASE_URL;
const baseurl = baseApiUrl + "api";
const baseurlforsla = baseurl + "/v1/sla";
export const BASE_URL_SLA = baseurlforsla;
export const GETALL_SLA = baseurlforsla;
export const ADD_SLA = baseurlforsla + "/addsla";
export const GET_SLA = baseurlforsla + "/getslabyid";
export const UPDATE_SLA = baseurlforsla + "/updatesla";
export const DELETE_SLA = baseurlforsla + "/deletesla";
